export enum CTALabel {
  Form = "form",
  Instructions = "instructions",
  Teleservice = "teleservice",
  NeedRegister = "is_teleservice_need_register",
  TeleservicePrefill = "teleservicePrefill",
  Link = "link",
}
